module.exports = __webpack_public_path__ + "img/homebg.c9505829.jpg";